import { Injectable, OnInit } from '@angular/core';
import { Observable, Subject, BehaviorSubject, lastValueFrom } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { HttpService } from 'src/app/modules/shared/services/http.service';
import { UserService } from 'src/app/modules/shared/services/user.service';
import { DeliveryCycle } from 'src/app/modules/order/interface/delivery-cycle';
import {HttpErrorResponse} from '@angular/common/http';
import {DeliveryChunk} from '../../admin/modules/delivery-chunk/interfaces/delivery-chunk';
import {LoadingService} from './loading.service';


@Injectable()
export class DeliveryCycleService {

  /**
   * Ein Array mit den derzeit geladenen Pflegekassen
   *
   * BehaviorSubject<Insurer[]>
   */
  private deliveryCycles: BehaviorSubject<DeliveryCycle[]>;

  /**
   * @var BehaviorSubject<Insurer>
   */
  private oneCycle: BehaviorSubject<DeliveryCycle>;

  /**
   *
   * @param http
   * @param toast
   * @param user
   */
  constructor(
    private http: HttpService, private toast: ToastrService, private user: UserService, private loading: LoadingService
  ) {
    this.oneCycle = new BehaviorSubject(null);
    this.deliveryCycles = new BehaviorSubject(null);
  }

  /**
   * Funktion zum holen der Lieferzyklen vom Server
   */
  public loadDeliveryCycles = () => {
    this.http.get('/api/delivery-cycle/list', this.setDeliveryCycles);
  }

  public getAllDeliveryCycles(): Observable<any> {
    return this.http.getWithoutCallback('/api/delivery-cycle/list');
  }

  /**
   * Gibt die Liste der Lieferzyklen als Observable zurück
   *
   * @returns Observable
   */
  public getDeliveryCycles = () => {
    this.loadDeliveryCycles();
    return this.deliveryCycles.asObservable();
  }

  /**
   * @param response
   */
  private setDeliveryCycles = (response: DeliveryCycle[]) => {
    this.deliveryCycles.next(response);
    this.loading.setLoadingState(false);
  }

  /**
   * @param cycle
   */
  public setDeliveryCycle = (cycle: DeliveryCycle) => {
    this.oneCycle.next(cycle);
  }

  /**
   * @returns Observable
   */
  public getDeliveryCycle = () => {
    return this.oneCycle.asObservable();
  }

  /**
   * Sendet die Anfrage zum erstellen eines neuen DeliveryChun-Datensatzes an den Server
   *
   * @param payload
   * @param callBack
   */
  public add = async (payload: any) => {
    return lastValueFrom(this.http.postWithoutCallback('/api/delivery-cycle/new', payload)).catch((e: HttpErrorResponse) => {
      return e;
    });
  }

  /**
   * @param deliveryCycle
   * @param payload
   */
  public update = async (deliveryCycle: DeliveryCycle, payload: any) => {
    const route = '/api/delivery-cycle/update/' + deliveryCycle.Id;
    return lastValueFrom(this.http.postWithoutCallback(route, payload)).catch((e: HttpErrorResponse) => {
      return e;
    });
  }

  /**
   * Funktion zum Löschen eines DeliveryChunk-Datensatzes
   *
   * @param deliveryCycle
   * @param callBack
   */
  public delete = (deliveryCycle: DeliveryCycle, callBack: Function) => {
    const route = '/api/delivery-cycle/delete/' + deliveryCycle.Id;
    this.http.post(route, {}, callBack);
  }

}
